import React, { useState, useEffect } from 'react';
import './ProgressiveImage.css';

const ProgressiveImage = ({ loResSrc, hiResSrc, ...props }) => {
    const [hiResLoaded, setHiResLoaded] = useState(false);
    const [hiResError, setHiResError] = useState(false);

    useEffect(() => {
        if (!hiResSrc) return;

        const img = new Image();
        
        img.onload = () => {
            setHiResLoaded(true);
        };
        
        img.onerror = () => {
            setHiResError(true);
        };
        
        img.src = hiResSrc;
    }, [hiResSrc]);

    return (
        <div className="progressive-image-wrapper">
            {/* Low-res image - establishes size, fades out after high-res is fully visible */}
            <img
                {...props}
                src={loResSrc}
                className={`progressive-image-lores ${props.className || ''}`}
                style={props.style}
                alt={props.alt}
            />
            
            {/* High-res image - overlays on top */}
            {hiResSrc && !hiResError && (
                <img
                    {...props}
                    src={hiResSrc}
                    className={`progressive-image-hires ${hiResLoaded ? 'loaded' : ''} ${props.className || ''}`}
                    style={props.style}
                    alt={props.alt}
                />
            )}
        </div>
    );
};

export default ProgressiveImage;
